var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowitworks1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6994 29.4015C60.6994 47.4051 47.1114 62 30.3497 62C13.588 62 0 47.4051 0 29.4015C0 11.3978 30.661 0 47.4227 0C64.1843 0 60.6994 11.3978 60.6994 29.4015Z",
    fill: "#F8EF24",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworks1);
export default __webpack_public_path__ + "static/media/howitworks1.1e03996d225b7078654f933f53d93438.svg";
export { ForwardRef as ReactComponent };